import { DateTime } from "luxon";
import React from "react";
import {
  CurrentProposal,
  useCurrentProposal,
} from "../../chat-plus-calendar/CurrentProposalContext";
import { ProposalOptionsOverlayV2 } from "../proposal-options-overlay-v2/ProposalOptionsOverlay";
import { getFullWidthPositionerData } from "./utils/getFullWidthPositionerData";

export const ProposalOptionsOverlayWrapperV2 = ({
  dateTime,
  calendarIds,
  minWidthPercent,
  maxFullColumns,
}: {
  dateTime: DateTime;
  calendarIds: string[];
  minWidthPercent: number;
  maxFullColumns: number;
}) => {
  const { currentProposal } = useCurrentProposal();
  const attendeeCalendarIdSet = getAttendeeCalendarIds(currentProposal);
  const attendeeCalendarIds = Array.from(attendeeCalendarIdSet);

  const { maxColumnsExceeded, columnCountOverride } = getFullWidthPositionerData(
    attendeeCalendarIds,
    calendarIds,
    maxFullColumns,
    minWidthPercent,
  );

  return (
    <ProposalOptionsOverlayV2
      dateTimes={[dateTime]}
      minWidth={minWidthPercent}
      columnCountOverride={columnCountOverride}
      positionerFullWidth={maxColumnsExceeded}
      popoverPosition="bottom"
      includeRail={false} // rail is only used for week view
    />
  );
};

const getAttendeeCalendarIds = (proposal: CurrentProposal) => {
  if (!proposal) return new Set<string>();

  // Get calendar IDs from all attendees
  const attendeeCalendarIds = new Set(
    proposal.attendees
      .filter((attendee) => attendee.user?.id) // Only include attendees with user IDs
      .map((attendee) => attendee.person.id),
  );

  return attendeeCalendarIds;
};
